import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import {
    SaveVetResponse,
    VetModel,
    VetClientModel,
    VetTaskClientModel,
    SetCustomerDecisionResponse
} from "../../models/vetting/vetting.models";
import { AutoScreeningRoutes } from "../../constants/vetting/vetting.constants";

@autoinject
export class AutoScreeningService {
    constructor(private requestClient: RequestClientService) {
    }

    public setCustomerDecision(vetId: number, customerDecisionStatusId: number, comments: string): Promise<SetCustomerDecisionResponse> {
        return this.requestClient.post(AutoScreeningRoutes.SetCustomerDecision, {}, {
            customerDecisionStatusId: customerDecisionStatusId,
            vetId: vetId,
            comments: comments
        });
    }

    public saveAutoScreening(manualDischargePort: boolean, manualLoadPort: boolean, dischargePortCountryId: number,
        loadPortCountryId: number, dischargePort: string, loadPort: string, charterTypeId: number, timeCharterStartDate: Date, timeCharterEndDate: Date, 
        vet: VetModel): Promise<SaveVetResponse> {
        return this.requestClient.post(AutoScreeningRoutes.SaveAutoScreening, {}, {
            manualDischargePort: manualDischargePort,
            manualLoadPort: manualLoadPort,
            dischargePortCountryId: dischargePortCountryId,
            loadPortCountryId: loadPortCountryId,
            dischargePort: dischargePort,
            loadPort: loadPort,
            charterTypeId: charterTypeId,
            timeCharterStartDate: timeCharterStartDate,
            timeCharterEndDate: timeCharterEndDate,
            vet: vet
        });
    }

    public getAutoScreening(id: number, includeVetTasks: boolean): Promise<VetClientModel> {
        return this.requestClient.get(`${AutoScreeningRoutes.GetAutoScreening}/${id}`, { includeVetTasks });
    }
    
    public getVetTasks(id: number): Promise<VetTaskClientModel[]> {
        return this.requestClient.get(`${AutoScreeningRoutes.GetVetTasks}/${id}`, {});
    }

    public changeStatus(id: number, vetStatusId: number, comments: string, meta: string, subtaskTypes: number[], statusSnippet: string,
        reopenStatusReasonId: number, failedRightShipCriteria: boolean, failedCustomerCriteria: boolean, cancellationStatusReasonId: number): Promise<void> {
        return this.requestClient.post(AutoScreeningRoutes.ChangeStatus, {}, {
            id: id,
            comments: comments,
            statusId: vetStatusId,
            meta: meta,
            subtaskTypes: subtaskTypes,
            statusSnippet: statusSnippet,
            reopenedReasonId: reopenStatusReasonId,
            cancellationStatusReasonId: cancellationStatusReasonId,
            failedRightShipCriteria: failedRightShipCriteria,
            failedCustomerCriteria: failedCustomerCriteria
        });
    }

    public rerunRules(vetId: number): Promise<void> {
        return this.requestClient.post(`${AutoScreeningRoutes.ReRunRules}/${vetId}`, {}, {});
    }
}
